var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Fill/pie-chart "
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9349 11.9776H21.0839C21.6259 11.9776 22.0499 12.4496 21.9959 12.9886C21.4519 18.4146 16.5799 22.5666 10.8819 21.9366C6.29694 21.4306 2.56994 17.7036 2.06294 13.1186C1.43494 7.42059 5.58494 2.54759 11.0119 2.00459C11.5519 1.95059 12.0229 2.37359 12.0229 2.91559V11.0666C12.0229 11.5696 12.4309 11.9776 12.9349 11.9776ZM21.1674 10.3331H14.5004C14.0404 10.3331 13.6674 9.96109 13.6674 9.50009V2.83309C13.6674 2.37309 14.0404 2.00009 14.5004 2.00009C18.6354 2.00009 22.0004 5.36409 22.0004 9.50009C22.0004 9.96109 21.6274 10.3331 21.1674 10.3331Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_20637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9349 11.9776H21.0839C21.6259 11.9776 22.0499 12.4496 21.9959 12.9886C21.4519 18.4146 16.5799 22.5666 10.8819 21.9366C6.29694 21.4306 2.56994 17.7036 2.06294 13.1186C1.43494 7.42059 5.58494 2.54759 11.0119 2.00459C11.5519 1.95059 12.0229 2.37359 12.0229 2.91559V11.0666C12.0229 11.5696 12.4309 11.9776 12.9349 11.9776ZM21.1674 10.3331H14.5004C14.0404 10.3331 13.6674 9.96109 13.6674 9.50009V2.83309C13.6674 2.37309 14.0404 2.00009 14.5004 2.00009C18.6354 2.00009 22.0004 5.36409 22.0004 9.50009C22.0004 9.96109 21.6274 10.3331 21.1674 10.3331Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_20637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.fab2f469fb19344725c779c7de71e81b.svg";
export { ForwardRef as ReactComponent };